/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateEntity } from './candidate-entity';
import { TagEntity } from './tag-entity';
export class CandidatesTagEntity extends Entity {
  candidate: CandidateEntity | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  tag: TagEntity | null = null;
  tagId: string | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidatesTag';
  static override get schema() {
    return {
      candidate: CandidateEntity,
      tag: TagEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesTag' in input
    ) {
      const { CandidatesTag: wrapped, ...rest } = input as {
        CandidatesTag: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}